import { Component, OnInit, Input, Optional, Self, ElementRef } from '@angular/core';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { ControlValueAccessor, UntypedFormGroup, NgControl, UntypedFormBuilder } from '@angular/forms';
import { Subject, of, interval,concat, Observable } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { FocusMonitor } from '@angular/cdk/a11y';
import { IntelliDataSelectorService } from './intelli-data-selector.service';


@Component({
  selector: 'intelli-data-selector',
  templateUrl: './intelli-data-selector.component.html',
  styleUrls: ['./intelli-data-selector.component.css'],
  providers: [

    { provide: MatFormFieldControl, useExisting: IntelliDataSelectorComponent },

  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
})
export class IntelliDataSelectorComponent implements MatFormFieldControl<number>, ControlValueAccessor, OnInit {

  _value: number;

  @Input()
  public options: any[] = [];
  
  updateGui(): any {
    
    if(this.isReady)
    {

    
      this.customerService.getItemForIntelliDataSelector(this.value,this.controllerName,this.methodNameForItem,this.options)
      .then(item => {
        this.parts.get("selectedId").setValue(item);
      })
    }
    
  }
  ngOnInit(): void {



    this.InitializeAutocompleteControls();

    this.isReady = true;

    this.updateGui();
    

  }

  @Input()
  public myCallback: Function;

  @Input()
  public controllerName: string = "x";

  @Input()
  public methodNameForList: string = "";

  @Input()
  public methodNameForItem: string = "";

  public isReady:boolean = false;

  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  //ngControl = null;
  errorState = false;
  controlType = 'intelli-data-selector';
  id = `intelli-data-selector-${IntelliDataSelectorComponent.nextId++}`;
  describedBy = '';
  public vendorOptions: Observable<any[]>;


  private onChange: (value: number) => void;

  writeValue(obj: number): void {

    this.value = obj;

  }
  registerOnChange(onChange: (value: number) => void): void {
    this.onChange = onChange;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.parts.get("selectedId").disable();
    }
    else {
      this.parts.get("selectedId").enable();
    }
  }


  get empty() {
    const { value: { selectedId } } = this.parts;

    // console.log("empty:" + dateText + !dateText);
    return !selectedId;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): number | null {

       return this._value;

  }

  set value(value: number | null) {

    value = value || 0;
 
  //  if (value > 0) {

      this._value = value;
  
      this.updateGui();

  //  }

    this.stateChanges.next();
  }


  public testecontroller()
  {
    console.log("Controller name :" + this.controllerName)
  }

  constructor(@Optional() @Self() public ngControl: NgControl,private  fb: UntypedFormBuilder,
   private fm: FocusMonitor,
    private elRef: ElementRef<HTMLElement>,
    private customerService: IntelliDataSelectorService) {

      this.parts = this.fb.group({
        selectedId: '0'
      });

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }


    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });

  
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {
    if ((event.target as Element).tagName.toLowerCase() != 'input') {
      this.elRef.nativeElement.querySelector('input')!.focus();
    }
  }


  displayVendorFn(vendor?: any): string | undefined {

    return vendor ? vendor.name : undefined;
  }

  public InitializeAutocompleteControls(): void {

    this.parts.get("selectedId").valueChanges
      .subscribe(data => {

  

        if(data.id != null)
        {

          this._value = data.id;
        }
        else{
          this._value = null;
        }



        this.onChange(this.value);

        this.vendorOptions = this.customerService
        .geListForIntelliDataSelector(0, 10, data,this.controllerName,this.methodNameForList,this.options);

      })


  }


}